import type { Contact } from "../types/phonebook";

export const sortContactsByName = (contacts: Contact[]) =>
  [...contacts].sort((a, b) =>
    a.contactName.localeCompare(b.contactName, undefined, {
      sensitivity: "base",
    }),
  );
